export const GOALS_PATH = '/impact/goals'
export const GOAL_DATE_FORMAT = 'YYYY-MM-DD'

export type TemplateCardData = {
  appcuesFlowId: string
  description: string
  goalTemplateCategory: string
  goalTemplateId: number
  goalTemplateTitle: string
  showInListing: boolean
}

export type CategoryCardsMap = { [key: string]: TemplateCardData[] }
